/**
 * AUTO-GENERATED by scripts/generate-module-manifest.ts
 * DO NOT EDIT THIS FILE BY HAND.
 *
 * Run `pnpm gen:modules` after adding, removing, or renaming a
 * module with a `ui/index.ts` route/layout export.
 */

/* eslint-disable */
// prettier-ignore-start

import type { RouteObject } from 'react-router'

import { accountingRoutes, AccountingLayout } from '../../../../modules/accounting/ui'
import { aiRoutes, AiLayout } from '../../../../modules/ai/ui'
import { carRentalRoutes, CarRentalLayout } from '../../../../modules/car-rental/ui'
import { chatRoutes, ChatLayout } from '../../../../modules/chat/ui'
import { connectorsRoutes, ConnectorsLayout } from '../../../../modules/connectors/ui'
import { crmRoutes, CrmLayout } from '../../../../modules/crm/ui'
import { dormitoryRoutes, DormitoryLayout } from '../../../../modules/dormitory/ui'
import { fleetRoutes, FleetLayout } from '../../../../modules/fleet/ui'
import { hrRoutes, HrLayout } from '../../../../modules/hr/ui'
import { inventoryRoutes, InventoryLayout } from '../../../../modules/inventory/ui'
import { marketingRoutes, MarketingLayout } from '../../../../modules/marketing/ui'
import { purchaseRoutes, PurchaseLayout } from '../../../../modules/purchase/ui'
import { salesRoutes, SalesLayout } from '../../../../modules/sales/ui'

/**
 * Protected module routes mounted under MainLayout.
 * The route path follows the module folder name.
 */
export const generatedModuleRoutes: RouteObject[] = [
  {
    path: '/accounting',
    Component: AccountingLayout,
    children: accountingRoutes,
  },
  {
    path: '/ai',
    Component: AiLayout,
    children: aiRoutes,
  },
  {
    path: '/car-rental',
    Component: CarRentalLayout,
    children: carRentalRoutes,
  },
  {
    path: '/chat',
    Component: ChatLayout,
    children: chatRoutes,
  },
  {
    path: '/connectors',
    Component: ConnectorsLayout,
    children: connectorsRoutes,
  },
  {
    path: '/crm',
    Component: CrmLayout,
    children: crmRoutes,
  },
  {
    path: '/dormitory',
    Component: DormitoryLayout,
    children: dormitoryRoutes,
  },
  {
    path: '/fleet',
    Component: FleetLayout,
    children: fleetRoutes,
  },
  {
    path: '/hr',
    Component: HrLayout,
    children: hrRoutes,
  },
  {
    path: '/inventory',
    Component: InventoryLayout,
    children: inventoryRoutes,
  },
  {
    path: '/marketing',
    Component: MarketingLayout,
    children: marketingRoutes,
  },
  {
    path: '/purchase',
    Component: PurchaseLayout,
    children: purchaseRoutes,
  },
  {
    path: '/sales',
    Component: SalesLayout,
    children: salesRoutes,
  },
]

// prettier-ignore-end
